module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAAEhyb7BAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATpJREFUeNpiYACCp74M/xmQGRgCAAHECGQIAOkEFiDxHiTCBMQfQAyAAIJJvZfeDGaD1H8AySZADShggAABgACCmXge2dT/DEiAiQENYAqAbEHiBwIEECPUUJBt8xmwAJAGkEXngWwDZEFslhsgCwAVBBCynwFdE8hNAAHEiGQCyPf9UO4FIHYEGgAJN5SAxgSJQIULQI58Dw877A4XZEJWgAPsZ2IgDAwwFCFFH+44wQIKQYoC0QQF0KJlAiNSKK9HU/wBqEAQxAAIMEYsUTKfCB9/gIbhBpgAPttgoBGI5WFpFwsIBBnIiBatWJMcgdiFB1I/A+Wgn4mBSoAFmkoNcCkg4CUYuABykSOsiMCmABRG0HC6gCcGHZHzEs48jgeAsxFGOoIaKACN6ngsXga5aiEQL4BlWBgAAE45YtfbZ5JvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/handlealarm/event_icon_not.png
// module id = UxOj
// module chunks = 4